import supplychain from "@assets/backdrops/supplychainstopic_3600x984.jpg"
import mining from "@assets/backdrops/metalsminingtopic_darkened_3600x984.jpg"
import oilgas from "@assets/backdrops/oilgastopic_darken_3600x984.jpg"
import climate from "@assets/backdrops/lfvol32024_3600x984.jpg"
import financial from "@assets/backdrops/globaltopic_3600x984.jpg"
import energy from "@assets/backdrops/energytransitiontopic_3600x984.jpg"
import agriculture from "@assets/backdrops/agribusinesstopic_darken_3600x984.jpg"

export const backdrops = [
  {
    backdrop: supplychain,
    blurb: `PGM is an S&P Global <span className="red">expertise-driven</span> 
              sector specific platform to provide future forecasting and projection
              via Monte Carlo simulations over classical Bayesian networks.`,
    title: "Getting Started",
  },
  {
    backdrop: agriculture,
    blurb: `Supply chains are opaque, even to participants. 
              Concentration of key inputs either by producer and location 
              creates unknown vulnerabilities that PGM's can 
              <span className='red'>expose in advance.</span>`,
    title: "Agriculture",
  },
  {
    backdrop: mining,
    blurb: `There is uncertainty due to <span className="red">many factors </span>
              with each upstream process, delivery and output affecting the
              processes downstream. Our experts model the total supply chain
              so that you can understand when one factor changes, 
              what happens further down the chain.`,
    title: "Metals & Mining",
  },
  {
    backdrop: oilgas,
    blurb: `Supply chain disruptions are becoming more frequent, more connected, 
              and, as a result, more consequential. PGM is a 
              <span className="red">transparent and flexible methodology</span> 
              that can quantify risks faced by individual producers
              from parts of their upstream supply chains.`,
    title: "Oil & Gas",
  },
  {
    backdrop: climate,
    blurb: `Quantify the business risks to your supply chains from economic,
              political, and <span className="red">climate shocks</span>, 
              by applying a range of different scenarios on the same model.`,
    title: "Climate Change",
  },
  {
    backdrop: financial,
    blurb: `Hedging instruments exist for pricing liquid commodities, 
              but less so for manufactured goods.
              Improve your ability to balance the efficiency and resiliency 
              of supply chains while <span className="red">accounting for risk.</span>`,
    title: "Financial Risk",
  },
  {
    backdrop: energy,
    blurb: `Changes can cascade rather than dampen interactions in the market, and
              competition is more and more between different supply chains, 
              not just individual firms, creating <span className="red">complex interdependencies</span> 
              and vulnerabilities.`,
    title: "Energy",
  },
]
